__turbopack_context__.v({
  "className": "libre_caslon_display_3d03c210-module__lh2A7W__className",
  "variable": "libre_caslon_display_3d03c210-module__lh2A7W__variable",
});
